module.exports = __webpack_public_path__ + "img/login-vertical-gris.1b77c72a.png";